export default "__VITE_ASSET__ku$a6xY5__"